import React from 'react';
import { FeatureSidebarButton } from '@lmt/signal-viewer-ui';

type GeneratePdfButtonProps = {
  onGenerateReport: () => void;
  isGenerating: boolean;
};

const PdfExportIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5 2C10.6326 2.00002 10.7598 2.05274 10.8535 2.14648L15.8535 7.14648C15.9473 7.24025 16 7.36741 16 7.5V15.5C16 16.8807 14.8807 18 13.5 18H5.5C4.1193 18 3 16.8807 3 15.5V4.5C3 3.1193 4.11931 2.00002 5.5 2H10.5ZM5.5 3C4.67159 3.00002 4 3.67158 4 4.5V15.5C4 16.3284 4.67159 17 5.5 17H13.5C14.3284 17 15 16.3284 15 15.5V8H12.5C11.1193 7.99998 10 6.8807 10 5.5V3H5.5ZM11 5.5C11 6.32842 11.6716 6.99998 12.5 7H14.293L11 3.70703V5.5Z'
        fill='currentColor'
      />
      <path
        d='M6.5 7C6.77614 7 7 7.22386 7 7.5V14.5C7 14.7761 6.77614 15 6.5 15C6.22386 15 6 14.7761 6 14.5V7.5C6 7.22386 6.22386 7 6.5 7ZM9.5 9C9.77614 9 10 9.22386 10 9.5V14.5C10 14.7761 9.77614 15 9.5 15C9.22386 15 9 14.7761 9 14.5V9.5C9 9.22386 9.22386 9 9.5 9ZM12.5 11C12.7761 11 13 11.2239 13 11.5V14.5C13 14.7761 12.7761 15 12.5 15C12.2239 15 12 14.7761 12 14.5V11.5C12 11.2239 12.2239 11 12.5 11Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const GeneratePdfButton: React.FC<GeneratePdfButtonProps> = ({
  onGenerateReport,
  isGenerating,
}) => {
  return (
    <FeatureSidebarButton
      icon={<PdfExportIcon />}
      label='Generate PDF report'
      tooltip={isGenerating ? 'Generating PDF...' : 'Generate PDF report'}
      disabled={isGenerating}
      onClick={onGenerateReport}
    />
  );
};
